export const LogoMark = ({ size = 36 }) => (
  <img src="/vmw-mark.png" alt="Vayora Media Works" width={size} height={size} style={{ width: size, height: size, objectFit: "contain" }} />
);

export default function Logo({ dark = false, collapsed = false, size = 36 }) {
  if (!dark && !collapsed) {
    return <img src="/vmw-logo.png" alt="Vayora Media Works" data-testid="brand-logo" style={{ height: size * 1.25, width: "auto", objectFit: "contain" }} />;
  }
  return (
    <div className="flex items-center gap-2.5 min-w-0" data-testid="brand-logo">
      <LogoMark size={size} />
      {!collapsed && (
        <div className="leading-tight min-w-0">
          <div className="font-display font-bold text-[16px] truncate text-white">Vayora</div>
          <div className="text-[10px] tracking-[0.12em] truncate text-violet-300">Media works</div>
        </div>
      )}
    </div>
  );
}
